import PageHeader from "@/components/molecules/PageHeader";
import { router } from "@inertiajs/react";
import Container from "@/components/atoms/Container";
import AccountForm from "@/components/organisms/Account/Form";
import useMessageProps from "@/hooks/useMessageProps";
import * as Constants from "@/constants";

export type FormFieldProps = {
  name: string;
  label: string;
  description?: string;
  placeholder?: string;
};

const NewAccount = (props: any) => {
  useMessageProps(props);

  const onSubmit = (data: any) => {
    router.post("/accounts", {
      ...data,
      initials: data.initials.toUpperCase(),
      status: data.status
        ? Constants.ACCOUNT_STATUSES.ACTIVE
        : Constants.ACCOUNT_STATUSES.INACTIVE,
    });
  };

  return (
    <Container>
      <PageHeader title="New Account" />
      <AccountForm
        edit={true}
        account={null}
        onSubmit={onSubmit}
        mode="create"
        errors={props.errors}
      />
    </Container>
  );
};

export default NewAccount;
